import {
    GET_UOM_LIST_PROGRESS, GET_UOM_LIST_SUCCESS, GET_UOM_LIST_FAILURE,
    ADD_UOM_PROGRESS, ADD_UOM_SUCCESS, ADD_UOM_FAILURE,
    EDIT_DELETE_UOM_PROGRESS, EDIT_DELETE_UOM_SUCCESS, EDIT_DELETE_UOM_FAILURE,

    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    uom: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const uom_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_UOM_LIST_SUCCESS:
            return { ...state, uom: action.uom, loading: false };
        case GET_UOM_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_UOM_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_UOM_PROGRESS:
            return { ...state, loading: true };
        case ADD_UOM_SUCCESS:
            return { ...state, uom: [...state.uom, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_UOM_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_UOM_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_UOM_SUCCESS:
            return {
                ...state,
                uom: state.uom.map((uom) =>
                    uom.id === action.payload.id ? action.payload : uom
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_UOM_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default uom_reducer;